export default __webpack_public_path__ + "static/media/thumb11_recipe@2x.383e240a.png";